import {
  Component, Input, ViewChild, ContentChild, ViewEncapsulation, HostListener
} from '@angular/core';
import { AccordionComponent, SidebarComponent, SidebarType } from '@syncfusion/ej2-angular-navigations';
import { fadeInOut } from '../../../shared/helpers/animations';

@Component({
  selector: 'app-custom-sidebar',
  templateUrl: './custom-sidebar.component.html',
  styleUrls: ['./custom-sidebar.component.scss'],
  animations: [fadeInOut],
  encapsulation: ViewEncapsulation.None,
})
export class CustomSidebarComponent {
  @ViewChild('customSidebar') public sidebar: SidebarComponent;

  // main form area that will be "pushed" to the right with transform X
  @Input() target = '.main-form';
  @Input() sidebarExpanded = false;

  // it should be assumed any accordion nested inside the sidebar will be named 'sidebarAccordion'
  @ContentChild('sidebarAccordion') accordionObj: AccordionComponent;

  clickEventArgs: Event;
  type: SidebarType = 'Push';
  enablePersistence = false;
  defaultSideBarTop = 98;

  onCreated(): void {
    this.sidebar.show();
  }

  openSidebarClick() {
    this.sidebar.show();
  }

  closeSideBarClick() {
    this.sidebar.hide();
  }

  expandAll() {
    this.sidebarExpanded = true;
    this.accordionObj?.expandItem(true);
  }

  collapseAll() {
    this.sidebarExpanded = false;
    this.accordionObj?.expandItem(false);
  }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll() {
    const scrollBarOffset = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;

    if (scrollBarOffset > 51) {
      this.defaultSideBarTop = 10;
    } else {
      this.defaultSideBarTop = 98;
    }
  }
  
}
